var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0ZM12 22.2C6.36 22.2 1.8 17.64 1.8 12C1.8 6.36 6.36 1.8 12 1.8C17.64 1.8 22.2 6.36 22.2 12C22.2 17.64 17.64 22.2 12 22.2ZM16.92 8.4L13.32 12L16.92 15.6C17.28 15.96 17.28 16.56 16.92 16.92C16.8 17.04 16.56 17.16 16.32 17.16C16.08 17.16 15.84 17.04 15.72 16.92L12.12 13.32L8.52 16.92C8.4 17.04 8.16 17.16 7.92 17.16C7.68 17.16 7.32 17.04 7.2 16.92C6.84 16.56 6.84 15.96 7.2 15.6L10.8 12L7.2 8.4C6.84 8.04 6.84 7.44 7.2 7.08C7.56 6.72 8.16 6.72 8.52 7.08L12.12 10.68L15.72 7.08C16.08 6.72 16.68 6.72 17.04 7.08C17.4 7.44 17.28 8.04 16.92 8.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRound);
export default __webpack_public_path__ + "static/media/close_round.818227cceee6ea933e40ac0f40496286.svg";
export { ForwardRef as ReactComponent };